import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import log from "loglevel";
import { Container, Row, Col } from "react-bootstrap";
import ReactGA from "react-ga";
import { sendPageView } from "lib/googleAnalytics/page";
import {
  getAccountsReducerResponse,
  getJwtReducerResponse,
} from "store/selectors";
import AccountsTable from "components/dashboard/account/AccountsTable";
import {
  getAccountsAction,
  decodeJwtAction,
} from "store/actions/actionCreators";
import MainNav from "components/nav/MainNav";
import {
  Breadcrumb,
  BreadcrumbData,
  InfoTableCard,
  Page,
} from "@avlino-inc/alenza-react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { Account, JWT } from "types";
import * as routes from "routes";
import { faFolders } from "@fortawesome/pro-light-svg-icons/faFolders";

const AccountsPage = ({ authed }: { authed: Promise<boolean> }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const accountsData: Account[] = useSelector((state) =>
    getAccountsReducerResponse(state, "data")
  );
  const jwtPayloadData: JWT = useSelector((state) =>
    getJwtReducerResponse(state, "data")
  );

  useEffect(() => {
    if (authed) {
      authed.then((allow) => {
        log.info("Allow: " + allow);
        if (allow) {
          log.info("Authenticated. Stay on page...");
          if (!accountsData) {
            log.info("No Accounts in store. Dispatching...");
            dispatch(getAccountsAction({}));
          }
        } else {
          log.info("Redirect back...");
          history.push(routes.LOGIN);
        }
      });
    } else {
      history.push(routes.LOGIN);
    }
  }, [authed, history, accountsData, dispatch]);

  /**
   * Google Analytics
   */
  useEffect(() => {
    sendPageView(location.pathname + location.search);
  }, [location]);
  
  useEffect(() => {
    dispatch(decodeJwtAction({}));
  }, []);

  const rowEvents = {
    onClick: (e: any, row: Account, rowIndex: number) => {
      history.push(routes.ACCOUNT(row.name.toLowerCase()));
    },
  };

  const breadcrumbItems = useMemo<BreadcrumbData[]>(
    () => [
      {
        url: routes.DASHBOARD_MAIN,
        label: "Command Center",
      },
      {
        url: routes.ACCOUNTS,
        label: "Accounts",
      },
    ],
    []
  );

  return (
    <div id="AccountsPage">
      <MainNav
        first_name={jwtPayloadData && jwtPayloadData.first_name}
        last_name={jwtPayloadData && jwtPayloadData.last_name}
        username={jwtPayloadData && jwtPayloadData.username}
        email={jwtPayloadData && jwtPayloadData.email}
      />
      <Container fluid={true} style={{ minWidth: "100%", margin: "15px" }}>
        <Page.Header>
          <Breadcrumb items={breadcrumbItems} onClickItem={history.push} />
        </Page.Header>
        <Row className="justify-content-md-center">
          <Col xs={12} md={10} lg={8} xl={6}>
            {accountsData ? (
              <InfoTableCard icon={faFolders} color="bright-blue">
                <AccountsTable
                  accounts={accountsData}
                  rowEvents={rowEvents}
                  cardTable={true}
                  showSearch={true}
                />
              </InfoTableCard>
            ) : null}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AccountsPage;
